<script setup>
import { ref, computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';
import { useI18n } from 'vue-i18n';

import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import Button from 'dashboard/components-next/button/Button.vue';
import CompaniesForm from './CompaniesForm.vue';

const emit = defineEmits(['create']);

const { t } = useI18n();

const dialogRef = ref(null);
const companiesFormRef = ref(null);
const company = ref(null);

const uiFlags = useMapGetter('companies/getUIFlags');
const isCreatingCompany = computed(() => uiFlags.value.creating);

const createNewCompany = companyItem => {
  company.value = companyItem;
};

const handleDialogConfirm = async () => {
  if (!company.value) return;
  emit('create', company.value);
};

const onSuccess = () => {
  companiesFormRef.value?.resetForm();
  dialogRef.value.close();
};

const closeDialog = () => {
  dialogRef.value.close();
};

defineExpose({ dialogRef, companiesFormRef, onSuccess });
</script>

<template>
  <Dialog ref="dialogRef" width="xl" @confirm="handleDialogConfirm">
    <CompaniesForm
      ref="companiesFormRef"
      is-new-company
      @update="createNewCompany"
    />
    <template #footer>
      <div class="flex items-center justify-between w-full gap-3">
        <Button
          :label="t('DIALOG.BUTTONS.CANCEL')"
          variant="link"
          type="reset"
          class="h-10 hover:!no-underline hover:text-n-brand"
          @click="closeDialog"
        />
        <Button
          type="submit"
          :label="t('COMPANIES.CREATE.SUBMIT')"
          color="blue"
          :disabled="companiesFormRef?.isFormInvalid ?? true"
          :is-loading="isCreatingCompany"
        />
      </div>
    </template>
  </Dialog>
</template>
